import { RteToolbarViewModel } from "rte-library";

export function permissionToolbar(toolbarObject: RteToolbarViewModel<any>) {

  toolbarObject.webAPIPrefixName = 'api/';
  toolbarObject.insertObjectName = 'InsertAsync';
  toolbarObject.updateObjectName = 'UpdateAsync';
  toolbarObject.deleteObjectName = 'DeleteAsync';
  toolbarObject.searchObjectName = 'GetAllAsync';

  return toolbarObject;
}


